export default "__VITE_ASSET__B52SnExv__"